import styled from "styled-components";
import { CustomButton } from "../../../../core/components/buttons/CustomButton";
import { IconButton } from "../../../../core/components/buttons/IconButton";
import { RadioButtonWithLabel } from "../../../../core/components/buttons/RadioButtonWithLabel";
import { H4, Small } from "../../../../core/styles/stringStyles";
import { useStyles } from "../../../../core/styles/theme";
import { hexWithOpacity } from "../../../../core/utils/helpers";

export type ContractAnswerProps = {
  onAcceptTerms: (accepted: boolean) => void;
  termsAccepted: boolean;
  fileUrl?: string;
  fileName?: string;
};

export const SignContractComponent = (props: ContractAnswerProps) => {
  if (!props.fileUrl) {
    return <div>Vertragsdetails fehlen</div>;
  }
  const theme = useStyles();
  const handleDownloadContract = () => {
    if (!props.fileUrl) {
      console.error("Contract details are missing");
      return;
    }
    window.open(props.fileUrl, "_blank");
  };

  return (
    <FieldsContainer>
      <LabeledIconButton onClick={handleDownloadContract}>
        <Label>{props.fileName ?? "Dokument ansehen"}</Label>
        <IconButton iconName="Document" primaryColor={theme.colors.medium} />
      </LabeledIconButton>
      <LawfulValidityBox>
        <IconButtonContainer>
          <IconButton
            iconName="Info"
            primaryColor={hexWithOpacity(theme.colors.medium, 0.5)}
          />
          <LawfulValidityTextContainer>
            <Label>Rechtlich gültige Unterschrift</Label>
            <StyledSmall>
              Indem Sie auf “Zustimmen” klicken, erklären Sie sich damit
              einverstanden, dass Ihr Name als elektronische Unterschrift in das
              Dokument {props.fileName ? `"${props.fileName}"` : ""} eingefügt
              wird.
            </StyledSmall>
          </LawfulValidityTextContainer>
        </IconButtonContainer>
      </LawfulValidityBox>
      <RadioButtonWithLabel
        isChecked={props.termsAccepted}
        onPress={props.onAcceptTerms}
        text="Ich habe das Dokument gelesen und stimme zu."
        checkBoxIconName="CheckBoxSquareInactive"
      />
    </FieldsContainer>
  );
};

const FieldsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const IconButtonContainer = styled(CustomButton)`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  padding: 10px 0px;
`;

const Label = styled(H4)`
  color: ${(props) => props.theme.colors.dark};
  text-align: left;
`;

const LawfulValidityBox = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px 15px 20px 15px;
  border-radius: 15px;
  background-color: ${(props) =>
    hexWithOpacity(props.theme.colors.medium, 0.1)};
  ${IconButtonContainer} {
    align-items: flex-start;
  }
`;

const StyledSmall = styled(Small)`
  color: ${(props) => props.theme.colors.medium};
  text-align: left;
`;

const LawfulValidityTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

const LabeledIconButton = styled(CustomButton)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
`;
